import React from 'react';
import { connect } from 'react-redux';
import { FetchWrapper } from 'element';
import { EMPLOYEE_DASHBOARD_MY_TIMESHEET } from 'state/FetchPageData/constants';
import { EmployeeDashboardLayout } from '../../components';
import View from './view';
import { BOX_MY_TIMESHEET_FETCH_PAGE_DATA_REQUEST } from '../../../../state/EmployeeDashboard/MyTimesheet/actions';
import { MyTimesheetHeader } from './components';

type OwnProps = {};

type StateProps = {};

type DispatchProps = {
  fetchData: () => void;
};

type Props = OwnProps & StateProps & DispatchProps;

const MyTimesheet = (props: Props) => (
  <EmployeeDashboardLayout header={<MyTimesheetHeader />}>
    <FetchWrapper {...props} pageId={EMPLOYEE_DASHBOARD_MY_TIMESHEET}>
      <View />
    </FetchWrapper>
  </EmployeeDashboardLayout>
);

const mapDispatchToProps: DispatchProps = {
  fetchData: BOX_MY_TIMESHEET_FETCH_PAGE_DATA_REQUEST
};

export default connect(
  null,
  mapDispatchToProps
)(MyTimesheet);
